<template>
	<div class="ma-1" ref="el">
		<template v-if="props.metadata === true">
			<default-field
				:props="{ ...props, metadata: false }"
				v-model="input[props.metadata_field]"
				@input="change"
			></default-field>
		</template>
		<template v-else-if="props.type == 'image'">
			<image-input
				v-model="input"
				:placeholder="item ? item[props.placeholder] : props.placeholder || input"
				:outlined="props.outlined"
				:rounded="props.rounded"
				:filled="props.filled"
				:solo="props.solo"
				:text="props.flat"
				:color="props.color"
				:large="props.large"
				:block="props.block"
				:dark="props.dark"
				:clear="props.clear"
				:dense="props.dense"
				:hide-details="!!props.hideDetails"
				:prepend-icon="props.prependIcon"
				@change="change"
				:readonly="props.readonly"
				:camera="props.camera"
				:rules="rules"
				:label="props.text | trans"
				:aspect-ratio="props.aspectRatio"
			></image-input>
		</template>

		<template v-else-if="props.type == 'file'">
			<v-text-field
				v-if="typeof input == 'string'"
				readonly
				full-width
				v-model="input"
				:outlined="props.outlined"
				:rounded="props.rounded"
				:filled="props.filled"
				:solo="props.solo"
				:text="props.flat"
				:dense="props.dense"
				:hide-details="!!props.hideDetails"
				:prepend-icon="props.prependIcon || 'cloud_download'"
				:rules="rules"
				:counter="props.counter"
				:label="props.text | trans"
				:disabled="props.disabled"
				:hint="props.hint"
				:min="props.min"
				:max="props.max"
				:persistent-hint="props.persistentHint"
				:href="props.getHref ? props.getHref(item) : api.url + input"
				append-icon="delete"
				@click:prepend="download(props.getHref ? props.getHref(item) : api.url + input)"
				@click:append="input = null"
			></v-text-field>
			<v-file-input
				v-else
				v-model="input"
				:prepend-icon="props.prependIcon"
				:append-icon="props.appendIcon"
				clearable
				@click:clear="
					input = null;
					change();
				"
				@change="
					input && input.length == 0 ? (input = null) : null;
					change();
				"
				:readonly="props.readonly"
				:outlined="props.outlined"
				:rounded="props.rounded"
				:filled="props.filled"
				:solo="props.solo"
				:text="props.flat"
				:dense="props.dense"
				:hide-details="!!props.hideDetails"
				:rules="rules"
				:counter="props.counter"
				:label="props.text | trans"
				:disabled="props.disabled"
				:type="props.type"
				:hint="props.hint"
				:min="props.min"
				:max="props.max"
				:persistent-hint="props.persistentHint"
				:multiple="props.multiple"
				:accept="props.accept"
				:show-size="props.showSize"
			>
				<template v-slot:selection="{ text }">
					<v-chip small label block="primary">{{ text }}</v-chip>
				</template>
			</v-file-input>
		</template>

		<template v-else-if="props.type == 'date' || props.type == 'month'">
			<v-menu
				ref="menuRef"
				:close-on-content-click="false"
				v-model="menuValue"
				transition="scale-transition"
				offset-y
				:nudge-right="40"
				min-width="290px"
				:return-value.sync="input"
			>
				<template v-slot:activator="{ on }">
					<v-text-field
						:clearable="!props.required"
						:hint="props.hint"
						:prepend-icon="props.prependIcon"
						v-on="on"
						@click:clear="
							input = null;
							change();
						"
						:outlined="props.outlined"
						:rounded="props.rounded"
						:filled="props.filled"
						:solo="props.solo"
						:text="props.flat"
						:dense="props.dense"
						:hide-details="!!props.hideDetails"
						:label="props.text | trans"
						:value="input | moment(props.format || (props.type === 'month' ? 'MMMM YYYY' : 'YYYY-MM-DD'))"
						:rules="rules"
						readonly
					></v-text-field>
				</template>
				<v-date-picker
					:allowed-dates="(date) => (props.allowedDates ? props.allowedDates(date, item, rules) : true)"
					@click:date="
						change();
						$refs.menuRef.save(input);
					"
					@click:month="
						if (props.type === 'month') {
							change();
							$refs.menuRef.save(input);
						}
					"
					v-model="input"
					:type="props.type"
					no-title
					scrollable
				>
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="menuValue = false">Cancel</v-btn>
					<v-btn
						text
						color="primary"
						@click="
							$refs.menuRef.save(input);
							change();
						"
						>OK</v-btn
					>
				</v-date-picker>
			</v-menu>
		</template>

		<template v-else-if="props.type == 'time'">
			<v-menu
				ref="menu"
				v-model="menuValue"
				:close-on-content-click="false"
				:nudge-right="40"
				:return-value.sync="input"
				transition="scale-transition"
				offset-y
				max-width="290px"
				min-width="290px"
			>
				<template v-slot:activator="{ on }">
					<v-text-field
						:outlined="props.outlined"
						:rounded="props.rounded"
						:filled="props.filled"
						:solo="props.solo"
						:text="props.flat"
						:dense="props.dense"
						:hide-details="!!props.hideDetails"
						:prepend-icon="props.prependIcon"
						:label="props.text | trans"
						:value="input | moment(props.format || 'hh:mm A')"
						:rules="rules"
						readonly
						@click:clear="
							input = null;
							change();
						"
						class="mt-0 pt-0"
						:clearable="!props.required"
						:hint="props.hint"
						v-on="on"
					></v-text-field>
				</template>
				<v-time-picker
					v-if="menuValue"
					v-model="input"
					@click:minute="
						change();
						$refs.menu.save(input);
					"
				>
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="menuValue = false">{{ "crud.cancel" | trans }}</v-btn>
					<v-btn text color="primary" @click="$refs.menu.save(input)">{{ "crud.save" | trans }}</v-btn>
				</v-time-picker>
			</v-menu>
		</template>

		<template v-else-if="props.type == 'datetime'">
			<template v-if="props.simple">
				<v-text-field
					:outlined="props.outlined"
					:rounded="props.rounded"
					:filled="props.filled"
					:solo="props.solo"
					:text="props.flat"
					:dense="props.dense"
					:hide-details="!!props.hideDetails"
					:prepend-icon="props.prependIcon"
					@change="change"
					color="primary"
					:readonly="props.readonly"
					:rules="rules"
					type="datetime-local"
					:label="props.text | trans"
					v-model="dateTimeLocal"
					@input="changeDateToLocal"
				></v-text-field>
			</template>

			<v-menu
				v-else
				ref="menu"
				v-model="menuValue"
				:close-on-content-click="false"
				:nudge-right="40"
				:return-value.sync="input"
				transition="scale-transition"
				offset-y
				@click="mode = 'date'"
				min-width="290px"
				max-width="290px"
			>
				<template v-slot:activator="{ on }">
					<v-text-field
						:outlined="props.outlined"
						:rounded="props.rounded"
						:filled="props.filled"
						:solo="props.solo"
						:text="props.flat"
						:dense="props.dense"
						:hide-details="!!props.hideDetails"
						:counter="props.counter"
						:rules="rules"
						:prepend-icon="props.prependIcon"
						:label="props.text | trans"
						:value="input | moment(props.format || 'YYYY-MM-DD hh:mm A')"
						class="mt-0 pt-0"
						readonly
						@click:clear="
							input = null;
							change();
						"
						:clearable="!props.required"
						:hint="props.hint"
						v-on="on"
					></v-text-field>
				</template>
				<v-date-picker
					:allowed-dates="(date) => (props.allowedDates ? props.allowedDates(date, item, rules) : true)"
					:min="props.min"
					v-if="mode === 'date'"
					v-model="date"
					no-title
					@input="mode = 'time'"
				></v-date-picker>
				<v-time-picker
					v-if="menuValue && mode !== 'date'"
					v-model="time"
					ampm-in-title
					use-seconds
					scrollable
					@click:second="
						input = `${date} ${time}`;
						change();
						$refs.menu.save(input);
						mode = 'date';
					"
				></v-time-picker>
			</v-menu>
		</template>

		<template v-else-if="props.type == 'boolean' || props.type == 'checkbox'">
			<v-checkbox
				:outlined="props.outlined"
				:rounded="props.rounded"
				:filled="props.filled"
				:solo="props.solo"
				:text="props.flat"
				:dense="props.dense"
				:hide-details="!!props.hideDetails"
				:prepend-icon="props.prependIcon"
				@change="change"
				color="primary"
				:readonly="props.readonly"
				:rules="rules"
				:label="props.text | trans"
				v-model="input"
			></v-checkbox>
		</template>

		<template v-else-if="props.type == 'relation' || props.type == 'resource' || props.type == 'relation_multiple'">
			<item-selector
				:ajax="props.ajax"
				:outlined="props.outlined"
				:rounded="props.rounded"
				:filled="props.filled"
				:solo="props.solo"
				:text="props.flat"
				:dense="props.dense"
				:hide-details="!!props.hideDetails"
				:modal="props.dialog"
				:prepend-icon="props.prependIcon"
				v-model="input"
				@input="change"
				:title="props.attribute || props.title"
				:description="props.description"
				:action="props.action"
				:trackBy="props.trackBy"
				:multiple="props.multiple || props.type == 'relation_multiple'"
				:image="props.image"
				:null-value="props.nullValue"
				:readonly="props.readonly"
				:rules="rules"
				:label="props.text | trans"
				:resource="props.resource"
				:items="props.options"
				:allow-edition="props.allowEdition"
			></item-selector>
		</template>

		<template v-else-if="props.type == 'select'">
			<v-autocomplete
				autocomplete="off"
				:outlined="props.outlined"
				:rounded="props.rounded"
				:filled="props.filled"
				:solo="props.solo"
				:chip="props.chip"
				:text="props.flat"
				:dense="props.dense"
				:hide-details="!!props.hideDetails"
				:prepend-icon="props.prependIcon"
				v-model="input"
				@input="change"
				:readonly="props.readonly"
				:rules="rules"
				:clearable="!props.required"
				:label="props.text | trans"
				:items="props.options"
				:multiple="props.multiple"
				:item-text="props.attribute || 'text'"
				:item-value="props.trackBy || 'value'"
			></v-autocomplete>
		</template>

		<template v-else-if="props.type == 'currency' || props.type == 'number'">
			<number-input
				:outlined="props.outlined"
				:rounded="props.rounded"
				:filled="props.filled"
				:solo="props.solo"
				:text="props.flat"
				:dense="props.dense"
				:hide-details="!!props.hideDetails"
				@input="change"
				:prepend-icon="props.prependIcon"
				:prepend-inner-icon="
					props.prependIcon ? props.prependIcon : props.type == 'currency' ? 'mdi-currency-usd' : undefined
				"
				:readonly="props.readonly"
				:rules="rules"
				:label="props.text | trans"
				v-model.number="input"
				:hint="input | money"
				:persistent-hint="true"
			></number-input>
		</template>

		<template v-else-if="props.type == 'extra'">
			<extra-input
				:outlined="props.outlined"
				:rounded="props.rounded"
				:filled="props.filled"
				:solo="props.solo"
				:text="props.flat"
				:dense="props.dense"
				:hide-details="!!props.hideDetails"
				v-model="input"
				@input="change"
				:rules="rules"
				:label="props.text"
				:default="props.default"
			></extra-input>
		</template>

		<template v-else-if="props.type == 'field_creator'">
			<meta-fields-creator
				:outlined="props.outlined"
				:rounded="props.rounded"
				:filled="props.filled"
				:solo="props.solo"
				:text="props.flat"
				:dense="props.dense"
				:hide-details="!!props.hideDetails"
				v-model="input"
				@input="change"
				:rules="rules"
				:label="props.text"
				:default="props.default"
			></meta-fields-creator>
		</template>

		<template v-else-if="props.type == 'component'">
			<component
				v-model="input"
				v-bind="props.props"
				:is="props.component"
				:props="props"
				:item="item"
				@input="change"
				:rules="rules"
				:label="props.text"
				:default="props.default"
			></component>
		</template>

		<template v-else-if="props.type == 'textarea'">
			<v-textarea
				:outlined="props.outlined"
				:rounded="props.rounded"
				:filled="props.filled"
				:solo="props.solo"
				:text="props.flat"
				:dense="props.dense"
				:hide-details="!!props.hideDetails"
				:prepend-icon="props.prependIcon"
				@input="change"
				:rows="props.rows || 2"
				:readonly="props.readonly"
				:rules="rules"
				:pattern="props.pattern"
				:counter="props.counter"
				:label="props.text | trans"
				v-model="input"
			></v-textarea>
		</template>

		<template v-else-if="props.type == 'richtext'">
			<!-- @blur="onEditorBlur($event)"
				@focus="onEditorFocus($event)"
			@ready="onEditorReady($event)"-->
			<quill-editor
				:style="`height:${props.height || '350px'}; margin-bottom:80px`"
				ref="myQuillEditor"
				v-model="input"
				:options="quillOptions"
				:prepend-icon="props.prependIcon"
				:rules="rules"
				:label="props.text | trans"
				@input="change"
			/>
		</template>

		<template v-else-if="props.type == 'password'">
			<v-text-field
				autocomplete="new-password"
				:outlined="props.outlined"
				:rounded="props.rounded"
				:filled="props.filled"
				:solo="props.solo"
				:text="props.flat"
				:dense="props.dense"
				:hide-details="!!props.hideDetails"
				:pattern="props.pattern"
				:prepend-icon="props.prependIcon"
				@input="change"
				:readonly="props.readonly"
				:rules="rules"
				:counter="props.counter"
				:label="props.text | trans"
				v-model="input"
				type="password"
				:hint="props.hint"
				:min="props.min"
				:max="props.max"
				:step="props.step"
			></v-text-field>
		</template>

		<template v-else-if="props.type == 'color'">
			<v-color-picker
				class="ma-2"
				:show-swatches="props.showSwatches"
				hide-canvas
				hide-mode-switch
				:outlined="props.outlined"
				:rounded="props.rounded"
				:filled="props.filled"
				:solo="props.solo"
				:text="props.flat"
				mode="hexa"
				width="auto"
				:dense="props.dense"
				:hide-details="!!props.hideDetails"
				:prepend-icon="props.prependIcon"
				@input="changeColor"
				:readonly="props.readonly"
				:rules="rules"
				:label="props.text | trans"
				v-model="input"
				:hint="props.hint"
			></v-color-picker>
		</template>

		<template v-else-if="props.type == 'location_picker' || props.type == 'location'">
			<map-location-picker
				@input="change"
				v-model="input"
				:label="props.text | trans"
				:multiple="props.multiple"
				:readonly="props.readonly"
				:item="item"
				:is-new="!item || item.id == null"
				v-bind="props.props"
			></map-location-picker>
		</template>

		<template v-else-if="props.type == 'hidden'">
			<input
				type="hidden"
				:name="props.value"
				v-model="input"
				:readonly="props.readonly"
				:rules="rules"
				:disabled="props.disabled"
			/>
			<template v-if="props.chip && input">
				<v-chip
					class="primary lighten-2"
					close
					@click:close="
						input = null;
						change();
					"
					><b class="text-uppercase">{{ props.name }}</b
					>: {{ input }}</v-chip
				>
			</template>
		</template>

		<template v-else>
			<v-text-field
				:outlined="props.outlined"
				:rounded="props.rounded"
				:filled="props.filled"
				:solo="props.solo"
				:text="props.flat"
				:dense="props.dense"
				:hide-details="!!props.hideDetails"
				:prepend-icon="props.prependIcon"
				@input="change"
				:pattern="props.pattern"
				:readonly="props.readonly"
				autocomplete="false"
				:rules="rules"
				:counter="props.counter"
				:label="props.text | trans"
				:disabled="props.disabled"
				v-model="input"
				:type="props.type"
				:hint="props.hint"
				:min="props.min"
				:max="props.max"
				:step="props.step"
				:persistent-hint="props.persistentHint"
			></v-text-field>
		</template>
	</div>
</template>
<script>
import validator from "@/services/validator";
import moment from "moment";
export default {
	name: "DefaultField",
	props: {
		value: {
			default: null,
		},
		item: {
			type: Object,
		},
		props: {
			type: Object,
			default: () => {
				return {
					text: "full name",
					value: "full_name",
					type: "text",
					dated: null,
					rules: [],
					hideDetails: false,
					solo: false,
					flat: false,
					dense: false,
					getHref: null,
				};
			},
		},
		noIcon: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		change() {
			this.$emit("input", this.input !== undefined ? this.input : null);
		},
		changeColor(ev) {
			if (ev && ev.hex && ev.hex !== this.input) {
				return this.$emit("input", ev.hex);
			}
			this.$emit("input", ev);
		},
		changeDateToLocal(val) {
			var value = moment(val).format("YYYY-MM-DDTHH:mm");
			this.input = value;
			this.$emit("input", value);
		},
		download(input) {
			window.open(input, "_system");
		},
	},
	filters: {
		number(value, decimals = 0) {
			if (value == undefined) return "--";
			return Number(value).toFixed(decimals);
		},
	},
	data() {
		return {
			quillOptions: {},
			menuValue: false,
			input: null,
			date: null,
			dateTimeLocal: null,
			time: null,
			mode: "date",
		};
	},
	computed: {
		rules: {
			immediate: true,
			get() {
				if (!this.props || !this.props.rules) return [];
				if (Array.isArray(this.props.rules)) return this.props.rules.map((func) => (v) => func(v, this.item));
				return validator.toRules(this.props.rules, this.item, this.props.field || this.props.value);
			},
		},
	},
	beforeMount() {
		const maxRows = 10;
		const maxCols = 5;
		const tableOptions = [];
		for (let r = 1; r <= maxRows; r++) {
			for (let c = 1; c <= maxCols; c++) {
				tableOptions.push("newtable_" + r + "_" + c);
			}
		}
		this.quillOptions = {
			modules: {
				toolbar: [
					[{ table: tableOptions }, { table: "append-row" }, { table: "append-col" }],
					["bold", "italic", "underline", "strike"],
					["blockquote", "code-block", "image"],

					[{ list: "ordered" }, { list: "bullet" }],

					[{ indent: "-1" }, { indent: "+1" }],
					[{ header: [1, 2, 3, 4, 5, 6, false] }],

					[{ color: [] }, { background: [] }],
					[{ font: [] }],
					[{ align: [] }],

					["clean"],
				],
				table: true,
			},
			placeholder: "",
			theme: "snow",
			readOnly: false,
		};
		this.input = this.value;
		if (this.props) {
			if (this.props.type == "datetime") {
				this.dateTimeLocal = moment(this.value).format("YYYY-MM-DDTHH:mm");
			}
			if (this.props.metadata) {
				this.input = this.input || this.value || {};
			}
		}
	},
	mounted() {
		if (this.props) {
			if (this.props.onfocus) {
				this.$refs.el.addEventListener(
					"focus",
					() => {
						this.props.onfocus(this.value, this.item);
					},
					true
				);
			}
			if (this.props.onblur) {
				this.$refs.el.addEventListener(
					"blur",
					() => {
						this.props.onblur(this.value, this.item);
					},
					true
				);
			}
		}
	},
	watch: {
		value() {
			if (this.props.metadata) {
				this.input = this.input || this.value || {};
			}
			this.input = this.value;
			if (this.props.type == "datetime") {
				this.dateTimeLocal = moment(this.value).format("YYYY-MM-DDTHH:mm");
			}
		},
		time() {
			if (this.time == null || this.props.type !== "datetime") return;
			this.input = this.date + " " + this.time;
		},
	},
};
</script>
